import {
  CurrentUserIdentity,
  isKnownValue,
  unknownUserIdentity,
} from 'shared/domain/currentUser/currentUserIdentity';

let currentUserIdentity = unknownUserIdentity;

/**
 * The logged-in user, as the page announced it, the permissions download
 * returned it or the worker stored it before it was stopped. An unknown user (the page has none yet) keeps the known one.
 */
export function rememberCurrentUser(identity: CurrentUserIdentity): void {
  if (isKnownValue(identity.id)) {
    currentUserIdentity = identity;
  }
}

/** Who the worker's logs belong to; `unknown` until a user is known. */
export function getCurrentUserIdentity(): CurrentUserIdentity {
  return currentUserIdentity;
}
